import { SKIP_DEFAULT_KEY } from "../constant";
import { isEmpty, isFunction } from "../utils";

// 调度中心
export default {
  data() {
    this.topic = new Map();

    return {};
  },

  methods: {
    subscribe(event, rule) {
      if (!this.topic.has(event)) {
        const taskMap = new Map();

        const unwatcher = this.$watch(event, (val, prevVal) => {
          if (val !== prevVal) {
            this.publish(event, val);
          }
        }, {
          deep: true,
          immediate: true,
        });

        this.topic.set(event, {
          task: taskMap,
          unwatcher,
        });
      }

      const topicEvent = this.topic.get(event);
      const eventTask = topicEvent.task;
      if (!eventTask.has(rule.value)) {
        eventTask.set(rule.value, rule.handler);
      }
    },
    
    publish(event, value) {
      const topicEvent = this.topic.get(event);
      if (isEmpty(topicEvent) || isEmpty(topicEvent.task)) return;

      const topicTask = topicEvent.task.get(value);
      if (isFunction(topicTask)) {
        return topicTask(value);
      }

      const defaultTask = topicEvent.task.get(SKIP_DEFAULT_KEY);
      if (isFunction(defaultTask)) {
        return defaultTask(value);
      }
    },

    unsubscribe(eventName) {
      const event = this.topic.get(eventName);
      isFunction(event.unwatcher) && event.unwatcher();
      this.topic.delete(eventName);
    },
    
    clearTopic() {
      this.topic.forEach((event) => {
        isFunction(event.unwatcher) && event.unwatcher();
      });
      this.topic = new Map();
    },
  },
};